import React, { useContext } from "react";
import { Badge, Button, LegacyCard as Card, Text, List, InlineStack } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { useLocation } from "react-router-dom";

const Heading = ({ isActive = false, monthlyFee = "", name = "", period = "", periodUnit = "" }) => {
  const { cms } = useContext(PrivateContext);

  return (
    <InlineStack blockAlign="center" wrap={false}>
      <Text variant="bodySm" as="h1">
        <InlineStack>
          <div>
            {name.toUpperCase()}
            {isActive && <Badge status={constant.INFO}>{cms("label.active")}</Badge>}
          </div>
        </InlineStack>
      </Text>
      <Text variant="heading2xl" as="p">
        {" "}
        <InlineStack>
          <div>
            {monthlyFee}
            <br />
            {period && (
              <Badge status={constant.INFO}>{`${period} ${periodUnit}${Number(period) > 1 ? "s" : ""}`}</Badge>
            )}
          </div>
        </InlineStack>
      </Text>
    </InlineStack>
  );
};

const PlanCard = ({ plan = {}, callback = () => {}, activePlan = "", submitLoading = false }) => {
  const { cms } = useContext(PrivateContext);
  const location = useLocation();
  const {
    code = "",
    currencyCode = "",
    description = "",
    isPopular,
    name = "",
    period = "",
    periodUnit = "",
    price = "",
    productLimit = "",
    trialPeriod,
    trialPeriodUnit = "",
  } = plan || {};

  const isUpdatePlanPage = location?.pathname === "/update/plan";
  const buttonText = isUpdatePlanPage ? cms("button.update") : cms("common.placeholder.select");

  const isActivePlan = activePlan === plan.code;
  const isDisabled = isUpdatePlanPage ? isActivePlan : !!activePlan;

  return (
    <Card key={code}>
      <Card.Section>
        <Heading
          code={code}
          period={period}
          periodUnit={periodUnit}
          isActive={isActivePlan}
          name={name}
          monthlyFee={`$${price}`}
        />
      </Card.Section>
      <Card.Section>
        <p>{description}</p>
        <br />
        <List>
          <List.Item key="sellerPlanProduct">{`${cms("common.label.productLimit")}: ${productLimit}`}</List.Item>
          <List.Item key="sellerPlanPeriod">
            {`${cms("common.label.plan")}: ${period} ${periodUnit}${Number(period) > 1 ? "s" : ""}`}
          </List.Item>
          <List.Item key="sellerPlanTrial">
            {`${cms("common.label.trial")}: ${trialPeriod} ${trialPeriodUnit}${Number(trialPeriod) > 1 ? "s" : ""}`}
          </List.Item>
        </List>
        <br />
        <Button variant="primary" fullWidth onClick={() => callback()} disabled={isDisabled} loading={submitLoading}>
          {buttonText}
        </Button>
      </Card.Section>
    </Card>
  );
};

export default PlanCard;
